import { isDashboardItemEditable, setDashboardItemTitle } from './dashboard-item';
import { openDatePicker } from './date-picker/date-picker';
import { refreshIssuePage, updateIssueGlance } from './events';
import { openCreateIssueDialog, openIssueDialog } from './issue';
import { initJQLEditor, showJQLEditor } from './jql-editor';
import { isNativeApp } from './platform';
import {
	getWorkflowConfiguration,
	_submitWorkflowConfigurationResponse,
} from './workflow-post-function';

/**
 * A JavaScript module which provides functions to interact with Jira.
 * @see WorkflowConfiguration
 * @see DashboardItem
 *
 * @module Jira
 * @product Jira
 */
export const jiraModule = {
	refreshIssuePage,
	updateIssueGlance,
	getWorkflowConfiguration,
	_submitWorkflowConfigurationResponse,
	isDashboardItemEditable,
	setDashboardItemTitle,
	openCreateIssueDialog,
	openIssueDialog,
	openDatePicker,
	initJQLEditor,
	showJQLEditor,
	isNativeApp,
};
